import {
  CanvasToolbar as StudioCanvasToolbar,
  type CanvasToolbarProps,
} from '@genieartinc/studio-ui/components/canvas/toolbar/canvas-toolbar'
import { TOOLBAR_TOOLS, DROPDOWN_ITEMS_MAP } from './toolbar-config'

export type { CanvasToolbarProps }

/**
 * studio-ui defaults to its own full tool list. The app defaults to the
 * feature-gated one instead, so a category that is switched off never reaches
 * the rail or the tool catalogue.
 */
export function CanvasToolbar({
  tools = TOOLBAR_TOOLS,
  dropdownItems = DROPDOWN_ITEMS_MAP,
  ...props
}: CanvasToolbarProps) {
  return <StudioCanvasToolbar {...props} tools={tools} dropdownItems={dropdownItems} />
}
